module.exports = __webpack_public_path__ + "img/24.ae651d5e.png";